import React  from "react";
import {
  TwitterOutlined,
  YoutubeOutlined,
  LinkedinOutlined
} from '@ant-design/icons';
import sprintlywh from "./sprintlywh.svg";
import "./footer.scss";
import {NavLink} from "react-router-dom";
const sec1 = [
  { url: "#", text: "Contact us" },
  { url: "#", text: "About Us" },
  { url: "www.fsdf.fds/fdsf", text: "Privacy policy" },
];
const sec2 = [
  { url: "#", text: "Hello " },
  { url: "#", text: "Test " },
  { url: "www.fsdf.fds/fdsf", text: "Support" },
];
const sec3 = [
  { url: "phone-to:", text: "+46760334777 " },
  { url: "#", text: "info@sprintly.co" },
  { url: "#", text: "Sprintly AB\n" +
        " Säljägarvägen 4 ,\n" +
        " 18464 Åkersberga, \n" +
        " Sweden." },
];

export const FooterSection = (props) => {
  const { title, list, path = '' } = props;
  // const renderList = () => {
  //     return list.map((val, index) => (
  //       <a key={index.toString()} className="section-list-item" href={val.url}>
  //         {val.text}
  //       </a>
  //     ));
  //   };
  const renderList = () => {
    let array = [];
    array = list.map((val, index) => {
      return (
        <a className="section-list-item" href={val.url}>
          {val.text}
        </a>
      );
    });
    return array;
  };
  //   const renderList2 = () => {
  //     const array = [];
  //     for (let i = 0; i < list.length; i++) {
  //       array[i] = (
  //         <a className="section-list-item" href={list[i].url}>
  //           {list[i].text}
  //         </a>
  //       );
  //     }
  //     return array;
  //   };
  return (
    <div className="section-container">
      <NavLink style={{ textDecoration: 'none'}} to={path}><span>{title}</span>
      </NavLink>
      <div className="section-list">{renderList()}</div>
    </div>
  );
};
export const Footer = () => {
  return (
    <div className="footer-container">
      <div className="top">
        <div className="logo-container">
          <img src={sprintlywh} />
        </div>
        <div className="footer-sections">
          <FooterSection title="About Us" path={'/about-us'} list={[]} />
          <FooterSection title="Contact Us" list={sec3} />

          {/*<div className="footer-corner">*/}
          {/*  <FooterSection title="About Us" list={sec1} />*/}
          {/*  <FooterSection title="contact Us" list={sec2} />*/}
          {/*</div>*/}
        </div>
      </div>

      <div className="bottom">
        <h3 style={{ color: 'white'}}>Copyright © 2021 Sprintly - All Rights Reserved.</h3>
        <div>
          <TwitterOutlined style={{ fontSize: 30, marginRight: 20 }}/>
          <YoutubeOutlined style={{ fontSize: 30, marginRight: 20 }}/>
          <LinkedinOutlined style={{ fontSize: 30, marginRight: 20 }}/>
        </div>
      </div>

    </div>
  );
};
